module.exports = __webpack_public_path__ + "static/media/menu.41c270db.png";